import 'htmx.org'
import Mark from 'mark.js/dist/mark.es6.min'

function markSearchText () {
  const searchValue = document.getElementById('search-input')?.value
  const resultsEl = document.getElementById('results')

  if (searchValue === undefined || resultsEl === undefined) {
    return
  }

  new Mark(resultsEl).mark(searchValue,
    {
      separateWordSearch: false,
      className: 'ams-mark'
    }
  )
}

// Highlight search text in search results
document.getElementById('results')?.addEventListener('htmx:afterSwap', markSearchText)
document.addEventListener('DOMContentLoaded', markSearchText)

// Open close accordion functionality
document.querySelectorAll('.ams-accordion__button').forEach(button => {
  button.addEventListener('click', function () {
    // Toggle aria-expanded attribute
    const isExpanded = this.getAttribute('aria-expanded') === 'true'
    this.setAttribute('aria-expanded', !isExpanded)

    // Get the associated panel
    const panelId = this.getAttribute('aria-controls')
    const panel = document.getElementById(panelId)

    // Toggle panel visibility
    panel.classList.toggle('ams-accordion__panel--expanded')
  })
})

// enable show more button functionality for filter list
document.querySelectorAll('.show-more-btn, .show-less-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    const panel = this.closest('.ams-accordion__panel')
    const isShowMore = this.classList.contains('show-more-btn')

    // Toggle options visibility
    // Count unchecked items separately to only show/hide first 5 unchecked
    let uncheckedCount = 0
    panel.querySelectorAll('.ams-checkbox').forEach((option) => {
      const checkboxInput = option.querySelector('.ams-checkbox__input')
      const isChecked = checkboxInput.checked

      // Checked items are always visible
      if (isChecked) {
        option.classList.remove('ams-visually-hidden')
        checkboxInput.tabIndex = 0
      } else {
        // Show/hide based on unchecked count
        if (uncheckedCount >= 5) {
          const shouldHide = !isShowMore
          option.classList.toggle('ams-visually-hidden', shouldHide)
          checkboxInput.tabIndex = shouldHide ? -1 : 0
        }
        uncheckedCount++
      }
    })

    // Toggle buttons visibility
    panel.querySelector('.show-more-btn').classList.toggle('ams-visually-hidden', isShowMore)
    panel.querySelector('.show-less-btn').classList.toggle('ams-visually-hidden', !isShowMore)
  })
})

// Sort checked items to the top of facets on page load
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ams-accordion__panel').forEach(panel => {
    const container = panel.querySelector('.ams-column--gap-extra-small')
    if (!container) return

    const checkboxes = Array.from(container.querySelectorAll('.ams-checkbox'))
    const showMoreContainer = container.querySelector('.show-more-container')

    // Separate checked and unchecked items
    const checked = checkboxes.filter(cb => cb.querySelector('.ams-checkbox__input')?.checked)
    const unchecked = checkboxes.filter(cb => !cb.querySelector('.ams-checkbox__input')?.checked)

    // If there are checked items, reorder
    if (checked.length > 0) {
      // Remove all checkboxes from DOM
      checkboxes.forEach(cb => cb.remove())

      // Re-add in order: checked first, then unchecked
      checked.forEach(cb => container.insertBefore(cb, showMoreContainer))
      unchecked.forEach(cb => container.insertBefore(cb, showMoreContainer))

      // Update visibility and tabindex based on new positions
      // Checked items are always visible, hide unchecked items beyond first 5 unchecked
      let uncheckedCount = 0
      const allCheckboxes = Array.from(container.querySelectorAll('.ams-checkbox'))
      allCheckboxes.forEach((checkbox) => {
        const checkboxInput = checkbox.querySelector('.ams-checkbox__input')
        if (!checkboxInput) {
          // Skip checkboxes without an input element
          return
        }
        // Checked items are always visible
        if (checkboxInput.checked) {
          checkbox.classList.remove('ams-visually-hidden')
          checkboxInput.tabIndex = 0
        } else {
          // Hide unchecked items beyond the first 5 unchecked items
          if (uncheckedCount >= 5) {
            checkbox.classList.add('ams-visually-hidden')
            checkboxInput.tabIndex = -1
          } else {
            checkbox.classList.remove('ams-visually-hidden')
            checkboxInput.tabIndex = 0
          }
          uncheckedCount++
        }
      })
    }
  })
})

// Filter search functionality for large facets
document.querySelectorAll('.filter-search-input').forEach(input => {
  input.addEventListener('input', function () {
    const filterIndex = this.getAttribute('data-filter-index')
    const searchTerm = this.value.toLowerCase()
    const panel = document.getElementById(`filter-panel-${filterIndex}`)
    const checkboxes = panel.querySelectorAll('.ams-checkbox')

    let visibleCount = 0
    let uncheckedCount = 0

    checkboxes.forEach((checkbox) => {
      const label = checkbox.querySelector('.ams-checkbox__label').textContent.toLowerCase()
      const matches = label.includes(searchTerm)
      const checkboxInput = checkbox.querySelector('.ams-checkbox__input')
      const isChecked = checkboxInput.checked

      // Checked items are always visible
      if (isChecked) {
        checkbox.classList.remove('ams-visually-hidden')
        checkboxInput.tabIndex = 0
      } else if (searchTerm === '') {
        // Restore original behavior: hide unchecked items beyond first 5 unchecked if "show less" is active
        const showLessBtn = panel.querySelector('.show-less-btn')
        const isShowLess = showLessBtn && !showLessBtn.classList.contains('ams-visually-hidden')
        const shouldHide = isShowLess && uncheckedCount >= 5
        checkbox.classList.toggle('ams-visually-hidden', shouldHide)
        // Make hidden items non-focusable
        checkboxInput.tabIndex = shouldHide ? -1 : 0
        uncheckedCount++
      } else {
        // When searching, show all matches
        checkbox.classList.toggle('ams-visually-hidden', !matches)
        // Make hidden items non-focusable
        checkboxInput.tabIndex = matches ? 0 : -1
      }

      if (!checkbox.classList.contains('ams-visually-hidden')) {
        visibleCount++
      }
    })

    // Hide show more/less buttons when search is active
    const showMoreContainer = panel.querySelector('.show-more-container')
    if (showMoreContainer) {
      showMoreContainer.style.display = searchTerm === '' ? '' : 'none'
    }
  })
})
